export default "__VITE_ASSET__CcHS3GCj__"